import React, { useContext, useState } from 'react'
import { FontAwesome } from '../data/FontAwesome';
import { AppContext } from '../AppContext';
import AlarmForm from './AlarmForm';
import NaflAlarmForm from './NaflAlarmForm';
import AlarmList from './AlarmList';

export default function Alarms() {
    const { t } = useContext(AppContext)
    const [activeTab, setActiveTab] = useState('alarm')
    const tabClass = (tab) => 'alarm-tab' + (activeTab === tab ? ' active' : '')

    return (

        <div className='alarms-panel'>
            <div className='menu-page-title'>{t('menu.alarms')}</div>
            <div className='mb-3'>
                <div className="alarm-tabs" role="tablist">
                    <button className={tabClass('alarm')} type="button" onClick={() => setActiveTab('alarm')}>
                        {FontAwesome.Plus} {t('alarms.addAlarm')}
                    </button>
                    <button className={tabClass('nafl')} type="button" onClick={() => setActiveTab('nafl')}>
                        {FontAwesome.Plus} {t('alarms.addNafl')}
                    </button>
                </div>
                <div className="alarm-form-card">
                    {activeTab === 'alarm' ? (<div>
                        <AlarmForm />
                    </div>) : null}
                    {activeTab === 'nafl' ? (<div>
                        <NaflAlarmForm />
                    </div>) : null}
                </div>
            </div>


            <AlarmList />


        </div>

    )
}
